export default __webpack_public_path__ + "static/media/doj_calendar.54eb9ace.svg";